// Shared CTA helpers for marketplace detail pages (QA sweep: wire all buttons).

/** Build the Messages compose deep-link, or null when there's no reachable owner
 *  (e.g. seeded demo listings have ownerUserId=null). */
export function messagesHref(
  toUserId: number | null | undefined,
  opts: { type?: string; id?: string; name?: string; intent?: string } = {},
): string | null {
  if (!toUserId) return null;
  const sp = new URLSearchParams();
  sp.set("to", String(toUserId));
  if (opts.type) sp.set("type", opts.type);
  if (opts.id) sp.set("id", opts.id);
  if (opts.name) sp.set("name", opts.name);
  if (opts.intent) sp.set("intent", opts.intent);
  return `/messages?${sp.toString()}`;
}

/** Copy the current page URL to the clipboard; returns true on success. */
export async function copyShareLink(): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(window.location.href);
    return true;
  } catch {
    return false;
  }
}

/** Open a print-ready résumé built from a person listing (browser Save-as-PDF). */
export function openResumePrint(p: any): void {
  const esc = (s: any) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c] as string));
  const skills: string[] = Array.isArray(p.skills) ? p.skills : [];
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(p.name)} — Résumé</title>
  <style>body{font-family:Inter,Arial,sans-serif;color:#0f2540;max-width:720px;margin:40px auto;padding:0 24px;line-height:1.5}
  h1{margin:0;font-size:28px} .sub{color:#5b6b7f;margin:2px 0 12px} .row{color:#5b6b7f;font-size:14px}
  h2{font-size:15px;border-bottom:2px solid #e33;padding-bottom:4px;margin-top:24px} .chip{display:inline-block;background:#f0f3f7;border-radius:6px;padding:3px 8px;margin:3px 4px 0 0;font-size:13px}
  @media print{body{margin:0}}</style></head><body>
  <h1>${esc(p.name)}</h1>
  <div class="sub">${esc(p.title || "")}</div>
  <div class="row">${esc(p.city || "")}${p.city ? ", Philippines" : ""} · ${esc(p.years || 0)} yrs experience${p.rate ? " · " + esc(p.rate) : ""}</div>
  <h2>About</h2>
  <p>${esc(p.title || "Professional")} with ${esc(p.years || 0)}+ years of experience across residential, commercial, and industrial work. Focused on safety, quality, and customer satisfaction.</p>
  <h2>Skills</h2>
  <div>${(skills.length ? skills : ["General"]).map((s) => `<span class="chip">${esc(s)}</span>`).join("")}</div>
  <h2>Contact</h2>
  <p class="row">Available through KontrataPH — ${esc(window.location.href)}</p>
  <script>window.onload=function(){window.print()}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  if (w) { w.document.write(html); w.document.close(); }
}
